import React from 'react';
import Categorylist from '../containers/Categorylist';
import Lists from '../containers/Lists';

const App = () => (
  <div className="app">
    <Lists />
    <Categorylist />
  </div>
);

export default App;
